import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowDown1 = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 24 24",
	xmlSpace: "preserve",
	enableBackground: "new 0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12,19.5c-0.7,0-1.3-0.3-1.7-0.8L0.4,7.6C-0.2,6.8-0.1,5.6,0.7,5c0.8-0.6,1.9-0.6,2.5,0.2l8.6,9.8 c0.1,0.1,0.2,0.1,0.4,0c0,0,0,0,0,0l8.6-9.8c0.7-0.8,1.8-0.9,2.6-0.2s0.9,1.8,0.2,2.6c0,0,0,0-0.1,0.1l-9.8,11.1 C13.3,19.2,12.6,19.5,12,19.5z",
		fill: "currentColor"
	})
});
export { SvgArrowDown1 as ReactComponent };
